import { ChevronDown } from "lucide-react";
import { cn } from "@punchup/utils/cn";

interface Props {
  label?: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}

export default function ViewMoreButton({
  label = "View More",
  onClick,
  className,
  disabled = false,
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "flex flex-row items-center justify-center leading-tight gap-x-1 bg-transparent text-primary-blue text-base font-semibold transition-colors ease-in-out duration-200 hover:bg-neutral-100 px-5 py-3 rounded-md",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      <span>{label}</span>
      <ChevronDown width={24} height={24} />
    </button>
  );
}
